<section class="employee-basket-card employee-basket-cart-archive-item">
  <mat-expansion-panel class="employee-basket-cart-archive-item__panel">
    <mat-expansion-panel-header>
      <mat-panel-title class="employee-basket-cart-archive-item__header">
        <mat-icon class="employee-basket-cart-archive-item__icon" [style.color]="wls.warnColor">
          shopping_cart
        </mat-icon>
        <div class="employee-basket-cart-archive-item__title-group">
          <span class="employee-basket-cart-archive-item__title">
            {{ cart().Name }}
          </span>
          @if (isOutsideChoicePeriod()) {
            <span class="employee-basket-cart-archive-item__period-hint">
              {{ 'employee.basket.outside-of-choice-period' | translate }}
            </span>
          }
        </div>
        <span
          class="employee-basket-cart-archive-item__count"
          [style.background-color]="wls.primaryColor"
          [style.color]="wls.primaryContrastingColor"
        >
          {{ benefitCount() }}
        </span>
        <span class="employee-basket-cart-archive-item__status" [style.color]="statusColor()">
          {{ presentation().statusTranslationKey | translate | uppercase }}
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>

    @for (section of sections(); track section.kind) {
      <div class="employee-basket-cart-archive-item__group">
        <div class="employee-basket-cart-archive-item__group-header">
          <mat-icon class="employee-basket-card__dot" [style.color]="sectionDotColor(section)">
            lens
          </mat-icon>
          <span>{{ section.titleKey | translate }}</span>
          <span
            class="employee-basket-cart-archive-item__count"
            [style.background-color]="sectionCountBackgroundColor(section)"
            [style.color]="sectionCountTextColor(section)"
          >
            {{ section.benefits.length }}
          </span>
        </div>

        @for (benefit of section.benefits; track benefit.id) {
          <div class="employee-basket-cart-archive-item__row">
            <div class="employee-basket-cart-archive-item__benefit-info">
              <div class="employee-basket-cart-archive-item__benefit-title">
                <span class="employee-basket-cart-archive-item__benefit-name">
                  {{ benefit.name }}
                </span>
                @if (rejectedOfferReason(section, benefit); as reason) {
                  <mat-icon
                    class="employee-basket-cart-archive-item__reject-info"
                    matTooltipClass="fo-field-info-tooltip"
                    svgIcon="fo-info"
                    tabindex="0"
                    [attr.aria-label]="reason"
                    [matTooltip]="reason"
                  ></mat-icon>
                }
              </div>
            </div>
            @if (rejectedOfferReason(section, benefit)) {
              <button
                class="employee-basket-cart-archive-item__reupload"
                type="button"
                (click)="onReuploadBenefit(benefit, $event)"
              >
                <mat-icon [svgIcon]="'fo-warn'"></mat-icon>
                <span>{{ 'employee.basket.reupload-document' | translate }}</span>
              </button>
            }
            <span class="employee-basket-cart-archive-item__amount">
              {{ displayAmount(benefit) | flexyooNumber }}
            </span>
          </div>
        }
      </div>
    }

    @if (showConfirmAndResign()) {
      <div class="employee-basket-cart-archive-item__footer">
        <span
          [matTooltip]="
            isConfirmAndResignDisabled()
              ? ('employee.basket.confirm-and-sign-disabled-tooltip' | translate)
              : ''
          "
          [matTooltipDisabled]="!isConfirmAndResignDisabled()"
        >
          <button
            matButton="filled"
            type="button"
            [class.employee-basket-cart-archive-item__confirm--impersonate]="
              actionPresentation().kind === 'signature-rejected'
            "
            [class.fo-color-error]="actionPresentation().kind !== 'signature-rejected'"
            [disabled]="isConfirmAndResignDisabled()"
            (click)="onSignCart()"
          >
            {{ 'employee.basket.confirm-and-resign' | translate }}
          </button>
        </span>
      </div>
    }
  </mat-expansion-panel>
</section>
